const EFFECTIVE_DATE = '21 สิงหาคม 2569';

export function PrivacyNotice() {
  return (
    <main>
      <article className="vra-card vra-privacy">
        <p className="vra-muted">มีผลใช้ตั้งแต่ {EFFECTIVE_DATE}</p>
        <h1>ประกาศความเป็นส่วนตัวสำหรับการสมัครสมาชิก</h1>

        <p>
          สมาคมนักวิทยุอาสาสมัคร (“สมาคม”) เป็นผู้ควบคุมข้อมูลส่วนบุคคลสำหรับระบบนี้
          หากมีคำถามหรือประสงค์ใช้สิทธิ โปรดติดต่อผู้จัดการสมาคมที่{' '}
          <a href="mailto:turakanvra@gmail.com">turakanvra@gmail.com</a> โทร.{' '}
          <a href="tel:+66988322522">098 832 2522</a> หรือส่งหนังสือถึง ตู้ ปณ.1 ปณฝ.บางแค
          กรุงเทพมหานคร 10161
        </p>

        <h2>ข้อมูลที่ใช้และวัตถุประสงค์</h2>
        <ul>
          <li>
            ข้อมูลระบุตัวตนและที่อยู่จากบัตรประชาชน ใช้กรอกใบสมัคร ตรวจการสมัครซ้ำ
            และให้ผู้จัดการบันทึกข้อมูลในระบบสำนักงาน กสทช.
          </li>
          <li>ข้อมูลติดต่อ ใช้แจ้งสถานะ ส่งใบสำคัญรับเงิน และติดต่อเกี่ยวกับใบสมัคร</li>
          <li>
            รูปที่ท่านเลือก ใช้จัดทำและบริหารบัตรสมาชิก ระบบไม่เลือกใช้ภาพใบหน้าจากบัตรแทนท่าน
          </li>
          <li>ข้อมูลธุรกรรมจากสลิป ใช้ตรวจยอด ผู้รับ รายการซ้ำ และออกหลักฐานการรับเงิน</li>
          <li>ข้อมูลเหตุการณ์ทางเทคนิคที่จำกัด ใช้รักษาความปลอดภัย ตรวจสอบ และแก้ปัญหา</li>
        </ul>

        <h2>สิ่งที่ระบบไม่เก็บ</h2>
        <ul>
          <li>ภาพบัตรประชาชนทั้งใบ ถูกใช้ในหน่วยความจำเพื่ออ่านข้อมูลแล้วทิ้งทันที</li>
          <li>ภาพสลิป ถูกอ่านในอุปกรณ์เป็นหลัก; กรณี fallback จะประมวลผลแล้วทิ้ง</li>
          <li>raw response, bounding boxes และข้อมูลที่ไม่จำเป็น เช่น ศาสนา</li>
        </ul>

        <h2>ฐานการประมวลผล</h2>
        <p>
          สมาคมประมวลผลข้อมูลที่จำเป็นเพื่อรับและดำเนินการตามคำขอสมัครสมาชิก
          ปฏิบัติหน้าที่ตามกฎหมายและข้อกำหนดทางบัญชี
          และเพื่อประโยชน์โดยชอบด้วยกฎหมายในการป้องกันการทุจริต การรักษาความปลอดภัย
          และการตรวจสอบย้อนหลัง
          ส่วนการใช้ภาพใบหน้าจากบัตรเป็นรูปสมาชิกจะเกิดขึ้นต่อเมื่อท่านเลือกอย่างชัดเจนเท่านั้น
        </p>

        <h2>ผู้รับข้อมูลและผู้ประมวลผล</h2>
        <ul>
          <li>Cloudflare: hosting, D1, private R2, Access และ Turnstile</li>
          <li>iApp: อ่านข้อมูลจากบัตรประชาชน โดยสมาคมไม่ส่งภาพไปเก็บในระบบของตน</li>
          <li>SlipOK: ตรวจข้อมูลธุรกรรมและสลิป</li>
          <li>Resend: ส่งอีเมลธุรกรรมและรับสถานะการส่ง</li>
          <li>ผู้จัดการสมาคมและสำนักงาน กสทช. เฉพาะข้อมูลที่จำเป็นต่อการดำเนินงาน</li>
        </ul>
        <p>
          ผู้ให้บริการบางรายอาจประมวลผลข้อมูลนอกประเทศไทย
          สมาคมจะใช้บริการเท่าที่จำเป็นและกำหนดมาตรการคุ้มครองที่เหมาะสม
        </p>

        <h2>ระยะเวลาเก็บและการลบ</h2>
        <ul>
          <li>ใบสมัครที่ค้างและไม่มีการชำระเงิน: ลบหลังไม่มีความเคลื่อนไหว 30 วัน</li>
          <li>
            ใบสมัครที่เสร็จสมบูรณ์หรือคืนเงินแล้ว: ลบข้อมูลระบุตัวตน ที่อยู่ ข้อมูลติดต่อ capability
            และรูปสมาชิกภายใน 90 วัน
          </li>
          <li>
            เก็บเฉพาะข้อมูลอ้างอิง ธุรกรรม ใบสำคัญรับเงิน และ audit metadata ที่ไม่ใช่ PII ไม่เกิน 7
            ปี แล้วลบทั้งรายการ
          </li>
          <li>ภาพบัตรประชาชนและภาพสลิป: ไม่จัดเก็บตั้งแต่ต้น</li>
        </ul>
        <p>
          หากมีข้อพิพาท การตรวจสอบ หรือคำสั่งตามกฎหมาย
          สมาคมอาจระงับการลบเฉพาะข้อมูลที่จำเป็นจนกว่าเรื่องนั้นสิ้นสุด
          โดยจำกัดการเข้าถึงระหว่างช่วงดังกล่าว
        </p>

        <h2>สิทธิของท่าน</h2>
        <p>
          ท่านอาจขอเข้าถึง รับสำเนา แก้ไข ลบ จำกัดหรือคัดค้านการประมวลผล
          ขอรับหรือโอนข้อมูลในกรณีที่กฎหมายกำหนด ถอนความยินยอมสำหรับส่วนที่อาศัยความยินยอม
          และร้องเรียนต่อสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล
          การถอนความยินยอมไม่กระทบการประมวลผลที่ทำไปก่อนถอน
        </p>
        <p>
          ข้อมูลที่ทำเครื่องหมายว่าจำเป็นต้องใช้เพื่อดำเนินการสมัครและตรวจการชำระเงิน
          หากไม่ให้ข้อมูลดังกล่าว สมาคมจะไม่สามารถรับใบสมัครผ่านระบบนี้ได้
        </p>

        <h2>การรักษาความปลอดภัย</h2>
        <p>
          ระบบเข้ารหัสเลขบัตรประชาชน จำกัดการเข้าถึงผู้จัดการด้วย Cloudflare Access เก็บรูปสมาชิกใน
          private R2 ใช้ anti-bot/rate limiting และไม่บันทึก PII ลง log เหตุการณ์สำคัญถูกบันทึกด้วย
          metadata ที่จำกัดเพื่อการตรวจสอบ
        </p>

        <p>
          <a href="/">กลับไปหน้าสมัครสมาชิก</a>
        </p>
      </article>
    </main>
  );
}
